import { render, staticRenderFns } from "./LinkedIn.vue?vue&type=template&id=1b441033&"
import script from "./LinkedIn.vue?vue&type=script&lang=js&"
export * from "./LinkedIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports